webpackJsonp([35783957827783],{

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Blockquote = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n'], ['\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  padding: 2rem 2rem 4rem;\n\n  ', ' {\n    fill: ', ';\n    height: 2.25rem;\n    position: absolute;\n    bottom: 0;\n    right: 0.5rem;\n    transform: translateY(150%);\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  padding: 2rem 2rem 4rem;\n\n  ', ' {\n    fill: ', ';\n    height: 2.25rem;\n    position: absolute;\n    bottom: 0;\n    right: 0.5rem;\n    transform: translateY(150%);\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tinycolor = __webpack_require__(27);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _QuoteMarksIcon = __webpack_require__(400);
	
	var _QuoteMarksIcon2 = _interopRequireDefault(_QuoteMarksIcon);
	
	var _vars = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var Blockquote = function Blockquote(_ref) {
	  var Tag = _ref.tag,
	      children = _ref.children,
	      quoteColor = _ref.quoteColor,
	      rest = _objectWithoutProperties(_ref, ['tag', 'children', 'quoteColor']);
	
	  return _react2.default.createElement(
	    Tag,
	    rest,
	    _react2.default.createElement(
	      Content,
	      null,
	      children,
	      _react2.default.createElement(_QuoteMarksIcon2.default, { 'aria-hidden': 'true' })
	    )
	  );
	};
	
	exports.Blockquote = Blockquote;
	Blockquote.propTypes = {
	  tag: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  quoteColor: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	Blockquote.defaultProps = {
	  tag: 'blockquote'
	};
	
	Blockquote.displayName = 'Blockquote';
	
	var StyledBlockquote = (0, _styledComponents2.default)(Blockquote)(_templateObject2, _QuoteMarksIcon2.default, function (_ref2) {
	  var quoteColor = _ref2.quoteColor;
	  return quoteColor;
	});
	
	StyledBlockquote.propTypes = {
	  quoteColor: _propTypes2.default.string
	};
	
	StyledBlockquote.defaultProps = {
	  quoteColor: (0, _tinycolor2.default)(_vars.COLORS.brand[1]).setAlpha(0.6).toRgbString()
	};
	
	exports.default = StyledBlockquote;

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Citation = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Citation = function Citation(_ref) {
	  var Tag = _ref.tag,
	      children = _ref.children,
	      rest = _objectWithoutProperties(_ref, ['tag', 'children']);
	
	  return _react2.default.createElement(
	    Tag,
	    rest,
	    _react2.default.createElement(
	      'cite',
	      null,
	      children
	    )
	  );
	};
	
	exports.Citation = Citation;
	Citation.propTypes = {
	  tag: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  children: _propTypes2.default.node
	};
	
	Citation.defaultProps = {
	  tag: 'footer'
	};
	
	Citation.displayName = 'Citation';
	
	exports.default = (0, _styledComponents2.default)(Citation)(_templateObject);

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n'], ['\n  display: flex;\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _List = __webpack_require__(62);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FlatList = (0, _styledComponents2.default)(_List2.default)(_templateObject);
	
	exports.default = FlatList;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n'], ['\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ListItem = __webpack_require__(63);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FlatListItem = (0, _styledComponents2.default)(_ListItem2.default)(_templateObject);
	
	exports.default = FlatListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HomePageMediaBlock = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n  display: ', ';\n\n  ', ' {\n    grid-row: 2;\n    background-color: ', ';\n  }\n\n  ', ' {\n    grid-row: 1;\n  }\n\n  ', ' .gatsby-image-outer-wrapper,\n  ', ' .gatsby-image-outer-wrapper > div {\n    height: 100%;\n  }\n\n  @media (min-width: ', ') {\n    display: grid;\n    grid-template-columns: repeat(', ', 1fr);\n    grid-gap: ', ';\n\n    ', ', ', ' {\n      grid-row: 1;\n    }\n\n    ', ' {\n      grid-column: ', ';\n      padding-left: ', ';\n      ', ';\n      margin-left: ', ';\n      margin-right: ', ';\n    }\n\n    ', ' {\n      grid-column: ', ';\n      margin-left: ', ';\n      margin-right: ', ';\n    }\n  }\n\n  &:not(:last-child) {\n    margin-bottom: 3rem;\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      padding-left: ', ';\n      ', ';\n    }\n  }\n'], ['\n  ', '\n  display: ', ';\n\n  ', ' {\n    grid-row: 2;\n    background-color: ', ';\n  }\n\n  ', ' {\n    grid-row: 1;\n  }\n\n  ', ' .gatsby-image-outer-wrapper,\n  ', ' .gatsby-image-outer-wrapper > div {\n    height: 100%;\n  }\n\n  @media (min-width: ', ') {\n    display: grid;\n    grid-template-columns: repeat(', ', 1fr);\n    grid-gap: ', ';\n\n    ', ', ', ' {\n      grid-row: 1;\n    }\n\n    ', ' {\n      grid-column: ', ';\n      padding-left: ', ';\n      ', ';\n      margin-left: ', ';\n      margin-right: ', ';\n    }\n\n    ', ' {\n      grid-column: ', ';\n      margin-left: ', ';\n      margin-right: ', ';\n    }\n  }\n\n  &:not(:last-child) {\n    margin-bottom: 3rem;\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      padding-left: ', ';\n      ', ';\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ZoomImage = __webpack_require__(138);
	
	var _ZoomImage2 = _interopRequireDefault(_ZoomImage);
	
	var _MediaBlockImageGroup = __webpack_require__(398);
	
	var _MediaBlockImageGroup2 = _interopRequireDefault(_MediaBlockImageGroup);
	
	var _Blockquote = __webpack_require__(392);
	
	var _Blockquote2 = _interopRequireDefault(_Blockquote);
	
	var _MarkdownBlock = __webpack_require__(115);
	
	var _MarkdownBlock2 = _interopRequireDefault(_MarkdownBlock);
	
	var _Citation = __webpack_require__(394);
	
	var _Citation2 = _interopRequireDefault(_Citation);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	var _arrayUtil = __webpack_require__(415);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SINGLE_ROW_BREAKPOINT = 850;
	
	var MEDIUM_SIZE_PADDING = 'calc(((1 / ' + _vars.TOTAL_GRID_UNITS + ') * 100vw) - ' + (0, _utils.pxToRem)(_vars.GUTTER_SIZE) + ')';
	var FULL_SIZE_PADDING = 'calc(' + (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH_PLUS * (1 / _vars.TOTAL_GRID_UNITS)) + ' - ' + (0, _utils.pxToRem)(_vars.GUTTER_SIZE) + ')';
	
	var take3 = (0, _arrayUtil.take)(3);
	
	var HomePageMediaBlock = function HomePageMediaBlock(props) {
	  var Tag = props.tag,
	      author = props.author,
	      testimonial = props.testimonial,
	      location = props.location,
	      images = props.images,
	      grayed = props.grayed,
	      padQuoteEvenly = props.padQuoteEvenly,
	      imageGridSize = props.imageGridSize,
	      quoteGridSize = props.quoteGridSize,
	      applyLeftMargin = props.applyLeftMargin,
	      applyRightMargin = props.applyRightMargin,
	      rest = _objectWithoutProperties(props, ['tag', 'author', 'testimonial', 'location', 'images', 'grayed', 'padQuoteEvenly', 'imageGridSize', 'quoteGridSize', 'applyLeftMargin', 'applyRightMargin']);
	
	  var quote = testimonial ? _react2.default.createElement(
	    _Blockquote2.default,
	    { quoteColor: grayed ? _vars.COLORS.gray[0] : undefined },
	    _react2.default.createElement(_MarkdownBlock2.default, { dangerouslySetInnerHTML: { __html: testimonial } }),
	    _react2.default.createElement(
	      _Citation2.default,
	      null,
	      author,
	      location && _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('br', null),
	        location
	      )
	    )
	  ) : null;
	
	  var renderImages = take3(images);
	
	  return _react2.default.createElement(
	    Tag,
	    rest,
	    quote,
	    _react2.default.createElement(
	      _MediaBlockImageGroup2.default,
	      { size: renderImages.length },
	      renderImages.map(function (img) {
	        return _react2.default.createElement(_ZoomImage2.default, { key: img.id, sizes: img.sizes, alt: img.alt });
	      })
	    )
	  );
	};
	
	exports.HomePageMediaBlock = HomePageMediaBlock;
	HomePageMediaBlock.propTypes = {
	  tag: CustomPropTypes.Tag,
	  author: _propTypes2.default.string,
	  testimonial: _propTypes2.default.string,
	  location: _propTypes2.default.string,
	  images: _propTypes2.default.arrayOf(CustomPropTypes.ImageSharp),
	  grayed: _propTypes2.default.bool,
	  padQuoteEvenly: _propTypes2.default.bool,
	  imageGridSize: _propTypes2.default.string,
	  quoteGridSize: _propTypes2.default.string,
	  applyLeftMargin: _propTypes2.default.func,
	  applyRightMargin: _propTypes2.default.func
	};
	
	HomePageMediaBlock.defaultProps = {
	  tag: 'article',
	  images: [],
	  imageGridSize: '1 / 7',
	  quoteGridSize: '7 / -1',
	  applyLeftMargin: function applyLeftMargin() {
	    return 0;
	  },
	  applyRightMargin: function applyRightMargin() {
	    return 0;
	  }
	};
	
	var StyledHomePageMediaBlock = (0, _styledComponents2.default)(HomePageMediaBlock)(_templateObject,
	/*
	When there is no testimonial, render element as a block.
	This works around a Moblie Safari issue.
	*/'', function (_ref) {
	  var testimonial = _ref.testimonial;
	  return testimonial ? 'grid' : 'block';
	}, _Blockquote2.default, function (_ref2) {
	  var grayed = _ref2.grayed;
	  return grayed ? _vars.COLORS.gray[1] : 'transparent';
	}, _MediaBlockImageGroup2.default, _ZoomImage2.default, _ZoomImage2.default, (0, _utils.pxToRem)(SINGLE_ROW_BREAKPOINT), _vars.TOTAL_GRID_UNITS, (0, _utils.pxToRem)(_vars.GUTTER_SIZE), _Blockquote2.default, _MediaBlockImageGroup2.default, _Blockquote2.default, function (_ref3) {
	  var quoteGridSize = _ref3.quoteGridSize;
	  return quoteGridSize;
	}, MEDIUM_SIZE_PADDING, function (_ref4) {
	  var padQuoteEvenly = _ref4.padQuoteEvenly;
	  return padQuoteEvenly && 'padding-right: ' + MEDIUM_SIZE_PADDING;
	}, function (_ref5) {
	  var applyLeftMargin = _ref5.applyLeftMargin,
	      quoteGridSize = _ref5.quoteGridSize;
	  return applyLeftMargin(quoteGridSize);
	}, function (_ref6) {
	  var applyRightMargin = _ref6.applyRightMargin,
	      quoteGridSize = _ref6.quoteGridSize;
	  return applyRightMargin(quoteGridSize);
	}, _MediaBlockImageGroup2.default, function (_ref7) {
	  var imageGridSize = _ref7.imageGridSize;
	  return imageGridSize;
	}, function (_ref8) {
	  var applyLeftMargin = _ref8.applyLeftMargin,
	      imageGridSize = _ref8.imageGridSize;
	  return applyLeftMargin(imageGridSize);
	}, function (_ref9) {
	  var applyRightMargin = _ref9.applyRightMargin,
	      imageGridSize = _ref9.imageGridSize;
	  return applyRightMargin(imageGridSize);
	}, (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH_PLUS), _Blockquote2.default, FULL_SIZE_PADDING, function (_ref10) {
	  var padQuoteEvenly = _ref10.padQuoteEvenly;
	  return padQuoteEvenly && 'padding-right: ' + FULL_SIZE_PADDING;
	});
	
	StyledHomePageMediaBlock.propTypes = {
	  imageGridSize: _propTypes2.default.string,
	  quoteGridSize: _propTypes2.default.string,
	  applyLeftMargin: _propTypes2.default.func,
	  applyRightMargin: _propTypes2.default.func
	};
	
	StyledHomePageMediaBlock.defaultProps = HomePageMediaBlock.defaultProps;
	
	exports.default = StyledHomePageMediaBlock;

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MediaBlockImageGroup = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', ' {\n    height: 100%;\n  }\n\n  ', ';\n'], ['\n  ', ' {\n    height: 100%;\n  }\n\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GatsbyImage = __webpack_require__(64);
	
	var _GatsbyImage2 = _interopRequireDefault(_GatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MediaBlockImageGroup = function MediaBlockImageGroup(_ref) {
	  var size = _ref.size,
	      rest = _objectWithoutProperties(_ref, ['size']);
	
	  return _react2.default.createElement('div', rest);
	};
	
	exports.MediaBlockImageGroup = MediaBlockImageGroup;
	MediaBlockImageGroup.propTypes = {
	  size: _propTypes2.default.number
	};
	
	exports.default = (0, _styledComponents2.default)(MediaBlockImageGroup)(_templateObject, _GatsbyImage2.default, function (_ref2) {
	  var _ref2$size = _ref2.size,
	      size = _ref2$size === undefined ? 0 : _ref2$size;
	
	  if (size < 2) {
	    return '';
	  }
	
	  var styles = ['display: grid;\n      grid-gap: 0.5rem;\n      position: relative;\n      grid-template-rows: repeat(' + Math.round(size / 2) + ', 1fr);\n      grid-template-columns: repeat(2, 1fr);'];
	
	  /*
	    If there's an odd number of images,
	    style the last one to fill the entire
	    last row
	  */
	  if (size % 2 === 1) {
	    styles.push('\n        > :last-child {\n          grid-row: ' + Math.round(size / 2) + ';\n          position: absolute !important;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          height: 100%;\n        }\n      ');
	  }
	
	  return styles.join('');
	});

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.QuoteMarks = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var QuoteMarks = exports.QuoteMarks = function QuoteMarks(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '50 390.191 400 220.617' }, props),
	    _react2.default.createElement(
	      'description',
	      null,
	      'Quotation Marks'
	    ),
	    _react2.default.createElement('path', {
	      d: 'M390.955,610.491c4.919,0,7.946-1.709,11.828-4.87c3.663-2.979,15.797-20.288,25.367-37.329 c14.306-25.501,21.655-46.753,21.813-63.184L450,408.904c0-10.314-8.386-18.713-18.701-18.713H292.236 c-10.304,0-18.702,8.398-18.702,18.713l0.024,116.248c0,10.327,8.386,18.726,18.701,18.726h81.983l0.659,3.663 c1.257,6.909,1.904,13.965,1.904,20.972c0,7.495-0.707,14.722-2.124,22.095c-0.243,1.525-0.317,2.404-0.317,3.271 C374.365,603.045,381.812,610.491,390.955,610.491L390.955,610.491z'
	    }),
	    _react2.default.createElement('path', {
	      d: 'M167.407,610.809c4.931,0,7.959-1.709,11.816-4.858c3.662-2.967,15.796-20.276,25.378-37.342 c14.319-25.513,21.655-46.765,21.814-63.171l0.048-96.229c0-10.303-8.398-18.688-18.701-18.688H68.7 c-10.314,0.001-18.7,8.387-18.7,18.688l0.013,116.272c0,10.303,8.386,18.713,18.701,18.713h81.983l0.671,3.675 c1.245,6.896,1.879,13.952,1.879,20.959c0,7.507-0.684,14.733-2.1,22.095c-0.256,1.525-0.33,2.417-0.33,3.271 C150.818,603.35,158.264,610.809,167.407,610.809L167.407,610.809z'
	    })
	  );
	};
	
	QuoteMarks.displayName = 'QuoteMarks';
	
	exports.default = (0, _styledComponents2.default)(QuoteMarks)(_templateObject);

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  z-index: 1;\n  transition: transform 3s;\n\n  &:hover {\n    transform: scale(1.15);\n  }\n'], ['\n  height: 100%;\n  z-index: 1;\n  transition: transform 3s;\n\n  &:hover {\n    transform: scale(1.15);\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n'], ['\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GatsbyImage = __webpack_require__(64);
	
	var _GatsbyImage2 = _interopRequireDefault(_GatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ZoomImage = (0, _styledComponents2.default)(_GatsbyImage2.default)(_templateObject);
	
	var ZoomImageWrapper = function ZoomImageWrapper(_ref) {
	  var className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ['className']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(ZoomImage, rest)
	  );
	};
	
	ZoomImageWrapper.displayName = 'ZoomImageWrapper';
	
	ZoomImageWrapper.propTypes = {
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _styledComponents2.default)(ZoomImageWrapper)(_templateObject2);
	module.exports = exports['default'];

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  flex-wrap: wrap;\n'], ['\n  flex-wrap: wrap;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  &:not(:last-child)::after {\n    content: \'\xB7\';\n    display: inline-block;\n    padding-left: 0.5rem;\n  }\n'], ['\n  &:not(:last-child)::after {\n    content: \'\xB7\';\n    display: inline-block;\n    padding-left: 0.5rem;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  padding: ', ';\n  grid-column: 1 / -1;\n  text-transform: uppercase;\n  margin-top: ', ';\n  margin-bottom: 3rem;\n\n  @media (min-width: ', ') {\n    ', ' {\n      max-width: calc(50vw - ', ');\n    }\n  }\n\n  @media (min-width: ', ') {\n    grid-column: 1 / 9;\n    margin-top: 0;\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      max-width: ', ';\n    }\n  }\n'], ['\n  background-color: ', ';\n  padding: ', ';\n  grid-column: 1 / -1;\n  text-transform: uppercase;\n  margin-top: ', ';\n  margin-bottom: 3rem;\n\n  @media (min-width: ', ') {\n    ', ' {\n      max-width: calc(50vw - ', ');\n    }\n  }\n\n  @media (min-width: ', ') {\n    grid-column: 1 / 9;\n    margin-top: 0;\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      max-width: ', ';\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  padding-bottom: ', ';\n\n  ', ' {\n    grid-column: 1 / -1;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  padding-bottom: ', ';\n\n  ', ' {\n    grid-column: 1 / -1;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _Container = __webpack_require__(119);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _HomePageMediaBlock = __webpack_require__(396);
	
	var _HomePageMediaBlock2 = _interopRequireDefault(_HomePageMediaBlock);
	
	var _Type = __webpack_require__(137);
	
	var _Type2 = _interopRequireDefault(_Type);
	
	var _FlatList = __webpack_require__(113);
	
	var _FlatList2 = _interopRequireDefault(_FlatList);
	
	var _FlatListItem = __webpack_require__(114);
	
	var _FlatListItem2 = _interopRequireDefault(_FlatListItem);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	var _homepage = __webpack_require__(417);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Services = (0, _styledComponents2.default)(_FlatList2.default)(_templateObject);
	
	var ServiceItem = (0, _styledComponents2.default)(_FlatListItem2.default)(_templateObject2);
	
	var Callout = _styledComponents2.default.hgroup(_templateObject3, _vars.COLORS.gray[1], (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 2), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroL), _Type2.default, (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 2), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroXL), (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH), _Type2.default, (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH / 2 - _vars.GUTTER_SIZE));
	
	var HomePage = function HomePage(props) {
	  var _props$data = props.data,
	      content = _props$data.content,
	      photos = _props$data.photos,
	      className = props.className;
	
	  var contentBlocks = (0, _homepage.mergeContentWithImages)(content, photos);
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _Container2.default,
	      { tag: 'section', plus: true, className: className },
	      _react2.default.createElement(
	        Callout,
	        null,
	        _react2.default.createElement(
	          _Type2.default,
	          { tag: 'h2' },
	          'Safety is our',
	          ' ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'number one'
	          ),
	          ' ',
	          'priority'
	        ),
	        _react2.default.createElement(
	          Services,
	          null,
	          _react2.default.createElement(
	            ServiceItem,
	            null,
	            'Concrete Flatwork'
	          ),
	          _react2.default.createElement(
	            ServiceItem,
	            null,
	            'Hardscapes'
	          ),
	          _react2.default.createElement(
	            ServiceItem,
	            null,
	            'Structural Concrete'
	          )
	        )
	      ),
	      contentBlocks.map(function (block) {
	        return _react2.default.createElement(_HomePageMediaBlock2.default, _extends({
	          key: block.author || block.images[0].id
	        }, block, {
	          applyLeftMargin: _homepage.applyLeftMargin,
	          applyRightMargin: _homepage.applyRightMargin
	        }));
	      })
	    )
	  );
	};
	
	HomePage.displayName = 'HomePage';
	
	HomePage.propTypes = {
	  data: _propTypes2.default.shape({
	    photos: CustomPropTypes.AllImageSharp,
	    content: CustomPropTypes.AllHomepageContent
	  }).isRequired,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _styledComponents2.default)(HomePage)(_templateObject4, (0, _utils.pxToRem)(70), _HomePageMediaBlock2.default);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.take = take;
	/* eslint-disable import/prefer-default-export */
	function take(qty) {
	  return function takeItems() {
	    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return items.slice(0, qty);
	  };
	}

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.applyRightMargin = exports.applyLeftMargin = exports.mergeContentWithImages = exports.cleanPropsForReact = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	var _images = __webpack_require__(140);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cleanPropsForReact = exports.cleanPropsForReact = function cleanPropsForReact(props) {
	  if (!props) {
	    return {};
	  }
	  return Object.keys(props).reduce(function (acc, key) {
	    if (props[key] !== null && props[key] !== undefined) {
	      acc[key] = props[key];
	    }
	    return acc;
	  }, {});
	};
	
	var mergeContentWithImages = exports.mergeContentWithImages = function mergeContentWithImages(content, images) {
	  return content.edges.reduce(function (acc, _ref) {
	    var _ref$node = _ref.node,
	        frontmatter = _ref$node.frontmatter,
	        html = _ref$node.html;
	
	    var props = cleanPropsForReact(frontmatter.props);
	
	    var result = _extends({
	      location: frontmatter.location,
	      author: frontmatter.author,
	      testimonial: html,
	      images: []
	    }, props);
	
	    result.images = (0, _images2.default)(images.edges, frontmatter.images);
	
	    acc.push(result);
	    return acc;
	  }, []);
	};
	
	var applyLeftMargin = exports.applyLeftMargin = function applyLeftMargin() {
	  var elmGridPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return parseInt(elmGridPosition, 10) === 1 ? (0, _utils.pxToRem)(_vars.GUTTER_SIZE) : 0;
	};
	
	var applyRightMargin = exports.applyRightMargin = function applyRightMargin() {
	  var elmGridPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var gridPositions = elmGridPosition.split('/');
	  if (!gridPositions.length === 2) {
	    return 0;
	  }
	  var endPosition = parseInt(gridPositions[1], 10);
	  return endPosition === -1 || endPosition === _vars.TOTAL_GRID_UNITS + 1 ? (0, _utils.pxToRem)(_vars.GUTTER_SIZE) : 0;
	};

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var composeImagesWithMetaData = function composeImagesWithMetaData(imageNodes, imageMeta) {
	  return imageMeta.reduce(function (acc, _ref) {
	    var imagePath = _ref.image,
	        alt = _ref.alt;
	
	    var matchImageNode = imageNodes.find(function (_ref2) {
	      var node = _ref2.node;
	      return node.id.match(imagePath);
	    });
	    if (!matchImageNode) {
	      return acc;
	    }
	    acc.push(_extends({}, matchImageNode.node, {
	      alt: alt
	    }));
	    return acc;
	  }, []);
	};
	
	exports.default = composeImagesWithMetaData;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4e840bdb2e9ce6ab4094.js